<template>
  <div class="pre-checkout-sidebar">
    <GenericModal
      ref="preCheckoutSidebarModal"
      :close-btn-color="'#231f20'"
      :close-btn-position="'in'"
      :exit-modal-icon-font-size="'18px'"
      :has-footer="false"
      :has-header="false"
      :max-width="'466px'"
      background-blur="none"
      border-radius="0px"
      unique-id="preCheckoutSidebarModal"
    >
      <div class="pre-checkout-sidebar-body">
        <PreCheckoutSidebarLogin
          v-show="loginVisible"
          @register-click="onRegisterClick"
          @guest-click="onGuestClick"
        >
          <template v-slot:error>
            <div v-if="hasError" class="pre-checkout-sidebar-header">
              <span class="pre-checkout-sidebar-header-error" v-html="currentViewError"></span>
            </div>
          </template>
        </PreCheckoutSidebarLogin>
        <PreCheckoutSidebarRegister
          v-show="registerVisible"
          @return-back-click="onReturnBackClick"
        >
          <template v-slot:error>
            <div v-if="hasError" class="pre-checkout-sidebar-header">
              <span class="pre-checkout-sidebar-header-error" v-html="currentViewError"></span>
            </div>
          </template>
        </PreCheckoutSidebarRegister>
        <PreCheckoutSidebarGuest
          v-show="guestVisible"
          @return-back-click="onReturnBackClick"
        >
          <template v-slot:error>
            <div v-if="hasError" class="pre-checkout-sidebar-header">
              <span class="pre-checkout-sidebar-header-error" v-html="currentViewError"></span>
            </div>
          </template>
        </PreCheckoutSidebarGuest>
      </div>
    </GenericModal>
  </div>
</template>

<script>

import GenericModal from './presentation/GenericModal'
import PreCheckoutSidebarLogin from './PreCheckoutSidebarLogin.vue'
import PreCheckoutSidebarRegister from './PreCheckoutSidebarRegister.vue'
import PreCheckoutSidebarGuest from './PreCheckoutSidebarGuest.vue'

export default {
  name: 'PreCheckoutSidebar',
  data () {
    return {
      currentView: 'login', // Possible values: 'login', 'register', 'guest'
      currentViewError: ''
    }
  },
  props: {
    error: {
      type: String,
      default: ''
    }
  },
  components: {
    GenericModal,
    PreCheckoutSidebarLogin,
    PreCheckoutSidebarRegister,
    PreCheckoutSidebarGuest
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search)
    const isModalOpen = urlParams.get('pre-checkout-sidebar-open')
    if (isModalOpen === 'true') {
      this.openModal()
    }

    if (this.error) {
      this.currentViewError = this.error
    }
  },
  computed: {
    loginVisible () {
      return this.currentView === 'login'
    },
    registerVisible () {
      return this.currentView === 'register'
    },
    guestVisible () {
      return this.currentView === 'guest'
    },
    hasError () {
      return !!this.currentViewError
    }
  },
  methods: {
    openModal () {
      this.$refs.preCheckoutSidebarModal.$emit('modal-open')
    },
    onRegisterClick () {
      this.currentViewError = ''
      this.currentView = 'register'
    },
    onGuestClick () {
      this.currentViewError = ''
      this.currentView = 'guest'
    },
    onReturnBackClick () {
      this.currentViewError = ''
      this.currentView = 'login'
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .cp-utilities-generic_modal {
  top: 108px;
  height:calc(100vh - 108px)!important;
  @media screen and (max-width: 1199px) {
    top: 55px;
    padding-top:30px;
    max-width: 505px!important;;
    height:calc(100vh - 55px)!important
  }
  @media screen and (max-width: 767px) {
    align-items: flex-start!important;
    top:65px;
    height:calc(100vh - 65px)!important
  }
}
::v-deep .cp-utilities-generic_modal-wrapper {
  z-index: 100;
  &.open {
    .cp-utilities-generic_modal-overlay {
      background: rgba(34, 33, 33, 0.4);
    }
  }
}
::v-deep .cp-utilities-generic_modal {
  padding: 0 !important;
  right: 0;
}
.pre-checkout-sidebar-header {
  display: grid;
  justify-items: center;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin-bottom: 1rem;
}
.pre-checkout-sidebar-header-error {
  padding: 10px;
  background: #ECCCCC;
  color: #D94444;
  font-size: 12px;
  box-shadow: 0 3px 6px #00000029;
}
.pre-checkout-sidebar-body {
  position: relative;
  display: grid;
  // max-height: 633px;
  max-height:100vh;
  overflow-y: auto;
  height:100%;
  align-content:center;
  @media screen and (max-width:767px){
    align-content:flex-start
  }
}
</style>
